<template>
  <div class="manage-default-box">
    <div class="main-box clear-both">
      <LeftNav :status='2'></LeftNav>
      <div class="customer-detail-display-box">
        <h2 v-if="customer.deleted_date !== ''">会員詳細 [退会]【{{ customer.name }}】</h2>
        <h2 v-else>会員詳細 【{{ customer.name }}】</h2>
          <div class="customer-info-box">
            <div class="info-left">
              <dl>
                <dt>会員ID</dt><dd>{{ customer_id }}</dd>
              </dl>
              <dl>
                <dt>ふりがな</dt><dd>{{ customer.f_name }}</dd>
              </dl>
              <dl>
                <dt>名前</dt><dd>{{ customer.name }}</dd>
              </dl>
              <dl>
                <dt>性別</dt><dd>{{ customer.sex }}</dd>
              </dl>
              <dl>
                <dt>生年月日</dt><dd>{{ customer.birthday }}</dd>
              </dl>
              <dl>
                <dt></dt><dd></dd>
              </dl>
            </div>
            <div class="info-right">
              <dl>
                <dt>電話番号</dt><dd>{{ customer.tel }}</dd>
              </dl>
              <dl>
                <dt>メールアドレス</dt><dd>{{ customer.mail }}</dd>
              </dl>
              <dl>
                <dt>郵便番号</dt><dd>{{ customer.zip_code }}</dd>
              </dl>
              <dl>
                <dt>都道府県</dt><dd>{{ customer.prefecture }}</dd>
              </dl>
              <dl>
                <dt>住所１(市町村名)</dt><dd>{{ customer.address1 }}</dd>
              </dl>
              <dl>
                <dt>住所２(番地・マンション名)</dt><dd>{{ customer.address2 }}</dd>
              </dl>
            </div>
          </div>
          <h2 class="h2-order-list">購入履歴</h2>
          <div class="menue-box">
            <p v-if="transition_type == 1" @click="customer_list_back" class="order-list-back-link">会員一覧へ戻る</p>
            <p v-else @click="order_list_back" class="order-list-back-link">注文一覧へ戻る</p>
            <div v-if="page_all_num > 1" class="paging-box">
              <div @click="page_shift(-1)">＜</div>
              <input type="text" v-model="page_num" @change="page_change()">
              <p>／</p>
              <p>{{ page_all_num }}</p>
              <div @click="page_shift(1)">＞</div>
            </div>
          </div>
          <div class="customer-order-list-box">
            <table>
              <thead>
                <tr>
                  <th v-for="item in list_head" :key="item.id" :class="item.class">{{ item.title }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in page_list">
                  <tr :key="item.id">
                    <td class="td-id">{{ item.id }}</td>
                    <td class="td-date">{{ item.order_date }}</td>
                    <td class="td-status">
                      <div v-if="item.status == 1" class="status-button status-button-selected-order">注文</div>
                      <div v-if="item.status == 2" class="status-button status-button-selected-accept">受付済み</div>
                      <div v-if="item.status == 3" class="status-button status-button-selected-product">製造中</div>
                      <div v-if="item.status == 4" class="status-button status-button-selected-shipping">発送済み</div>
                    </td>
                    <td class="td-detail">
                      <div v-if="item.status == 4" class="item-info-box address-box">
                        <p class="title">発送日</p>
                        <p class="content">{{ item.updated_date }}</p>
                      </div>
                      <div class="item-info-box address-box">
                        <p class="title">お届け先</p>
                        <p class="content">{{ item.name }}</p>
                        <p class="content zip-code">〒{{ item.zip_code }}</p>
                        <p class="content">{{ item.prefecture }}{{ item.address1 }}{{ item.address2 }}</p>
                      </div>
                      <template v-for="order in item.orders">
                        <div class="item-box" :key="order.id">
                          <div class="item-info-box kind-box">
                            <p class="title">種類</p>
                            <p class="content" v-for="order_item in order.items" :key="order_item.id">{{ order_item.name }}</p>
                          </div>
                          <div class="item-info-box type-box">
                            <p class="title">焙煎</p>
                            <p class="content">{{ type_name[order.type] }}</p>
                          </div>
                          <div class="item-info-box weight-box">
                            <p class="title">量</p>
                            <p class="content">{{ order.weight }} g</p>
                          </div>
                          <div class="item-info-box num-box">
                            <p class="title">個数</p>
                            <p class="content">{{ order.num }}</p>
                          </div>
                        </div>
                      </template>
                      <div class="item-info-box price-box">
                        <p class="title">価格</p>
                        <p class="content">{{ yen_separate(item.price) }} 円 (税 {{ yen_separate(item.tax) }} 円、送料 {{ yen_separate(item.post_price) }} 円)</p>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftNav from '@/views/components/manage/LeftNav';

export default {
  name: 'customerDetail',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    LeftNav,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      step: 500,
      page_num: 1,
      transition_type: 0,
      customer_id: 0,
      customer: {},
      list: [],
      list_head: [
        {id: 1, title: '注文ID', class: 'th-id'},
        {id: 2, title: '注文日', class: 'th-date'},
        {id: 3, title: 'ステータス', class: 'th-status'},
        {id: 4, title: '注文詳細', class: 'th-detail'}
      ],
      type_name: {1: '浅煎り', 2: '中煎り', 3: '深煎り'},
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    page_all_num () { return Math.ceil(this.list.length / this.step); },
    page_list() {
      let start_page = (this.page_num - 1) * this.step;
      return this.list.slice(start_page, start_page + this.step);
    },
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.customer_id = this.$route.params.id;
    this.transition_type = this.$route.params.type;
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    let ld = new this.$loader(this);
    ld._m_data_set({token: this.$store.getters['mLoginInfo/login_token'],
      customer_id: this.customer_id});
    ld._post_cb_f = this.customer_detail_get_cb;
    ld._load_start('manage/customer_detail_get.php');
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    customer_detail_get_cb (data) {
      if (data.res === 1) {
        this.customer = data.data.customer;
        this.list = data.data.list;
      } else {
        this.$alert('alert', `エラーコード：${data.data.res}`);
      }
    },
    date_br (date_str) {
      return date_str.replace(' ', '<br>');
    },
    order_list_back () {
      this.$router.push({path: '/manage/main'});
    },
    customer_list_back () {
      this.$router.push({path: '/manage/customer_list'});
    },
    page_change () {
      if (this.page_all_num < this.page_num) {
        this.page_num = this.page_all_num;
      }
    },
    page_shift (num) {
      let check_num = this.$lib._pint(this.page_num) + num;
      if (check_num > 0 && check_num <= this.page_all_num) {
        this.page_num = check_num;
      }
    },
    yen_separate (num) {
      return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.manage-default-box {
  .main-box {
    display: flex;
  }
  .customer-detail-display-box {
    min-width: 1108px;
    flex: 1;
    padding: 16px;
    .h2-order-list {
      margin-top: 10px;
    }
    .customer-info-box {
      display: flex;
      justify-content: center;
      margin: 23px 0 20px 0;
      .info-left, .info-right {
        width: 550px;
      }
      dl {
        display: flex;
        background-color: #fefefe;
      }
      dl:first-child {
        border-top: 1px solid #bdba8f;
      }
      dt {
        width: 240px;
        height: 33px;
        color: #fff;
        padding: 5px;
        border-bottom: 1px solid #bdba8f;
        box-sizing: border-box;
        background-color: #738f53;
      }
      dl:last-child dt {
        border-bottom: 1px solid #bdba8f;
      }
      dd {
        width: 310px;
        text-align: left;
        font-weight: bold;
        box-sizing: border-box;
        padding: 0 10px;
        height: 33px;
        line-height: 33px;
        border-bottom: 1px solid #bdba8f;
        border-right: 1px solid #bdba8f;
      }
    }
    .menue-box {
      display: flex;
      justify-content: space-between;
      margin: 0 auto 10px auto;
      padding: 0 10px;
      width: 870px;
      .order-list-back-link {
        text-decoration: underline;
        color: #9c5360;
        margin: auto 0;
        cursor: pointer;
      }
      .order-list-back-link:hover {
        color: #e91f42;
      }
      .paging-box {
        width: 250px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 30px;
        input[type="text"] {
          text-align: right;
          height: 30px;
          width: 40px;
        }
        div {
          padding: 0 25px;
          margin: 0 10px;
          height: 30px;
          line-height: 32px;
          text-align: center;
          background-color: #cfcebc;
          border-radius: 5px;
          color: #FFF;
          font-weight: bold;
          cursor: pointer;
        }
        div:hover {
          background-color: #738f53;
        }
      }
    }
    .customer-order-list-box {
      table {
        margin: 0 auto;
        thead {
          display:block;
          tr {
            background-color: $manage-table-head-bg-color;
          }
          th {
            border: 1px solid $manage-table-border-color;
            border-bottom: none;
            padding: 5px 0;
          }
          th.th-id {
            min-width: 80px;
          }
          th.th-date {
            min-width: 230px;
          }
          th.th-status {
            min-width: 150px;
          }
          th.th-detail {
            width: 400px;
          }
        }
        tbody{
          display:block;
          overflow-y:scroll;
          height: calc(100vh - 430px);
          min-height: 180px;
          td {
            border: 1px solid $manage-table-border-color;
          }
          td.td-id {
            min-width: 80px;
          }
          td.td-date {
            min-width: 230px;
          }
          td.td-status {
            min-width: 150px;
            div.status-button {
              border: 1px solid;
              margin: 10px auto;
              border: 1px solid #FFF;
              border-radius: 10px;
              width: 80px;
              height: 30px;
              line-height: 30px;
              font-weight: bold;
              box-sizing: border-box;
            }
            div.status-button-selected-order {
              color: #107ca0;
            }
            div.status-button-selected-accept {
              color: #bb130c;
            }
            div.status-button-selected-product {
              color: #14a55c;
            }
            div.status-button-selected-shipping {
              color: #bb870f;
            }
          }
          td.td-detail {
            width: 400px;
            .item-box {
              display: flex;
              border-bottom: 1px solid $manage-table-border-color;
              .item-info-box {
                text-align: left;
                padding: 0 5px;
                box-sizing: border-box;
                border-right: 1px solid $manage-table-border-color;
                .title {
                  margin-top: 3px;
                  font-size: 0.7rem;
                  font-weight: bold;
                }
                .content {
                  margin-left: 5px;
                  font-size: 0.9rem;
                }
              }
              .item-info-box:last-child {
                border-right: none;
              }
              .kind-box {
                width: 180px;
              }
              .type-box {
                width: 90px;
                .content {
                  text-align: center;
                }
              }
              .weight-box {
                width: 70px;
                .content {
                  text-align: center;
                }
              }
              .num-box {
                width: 60px;
                .content {
                  text-align: center;
                }
              }
            }
            .price-box {
              background-color: $manage-table-bg-sub-color;
              .title {
                font-size: 0.7rem;
                font-weight: bold;
              }
            }
            .address-box {
              line-height: 1.5;
              text-align: left;
              padding: 0 5px;
              box-sizing: border-box;
              border-bottom: 1px solid $manage-table-border-color;
              .title {
                color: #080808;
                margin-top: 3px;
                font-size: 0.7rem;
                font-weight: bold;
              }
              .content.zip-code {
                font-size: 0.8rem;
              }
            }
          }
        }
      }
    }
  }
}
</style>
